var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "a-spin",
    { attrs: { spinning: _vm.isLoading } },
    [
      _c("a-tree-select", {
        attrs: {
          treeData: _vm.categoryListTree,
          dropdownStyle: { maxHeight: "500px", overflow: "auto" },
          allowClear: "",
        },
        on: { change: _vm.onChange },
        model: {
          value: _vm.selectedId,
          callback: function ($$v) {
            _vm.selectedId = $$v
          },
          expression: "selectedId",
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }